$( document ).ready(function() {
 var c =  $('.mmc-sort-desktop').find('input:checked').val();
    console.log(c);
  $('.mmc-sort-header').html(c);
  $('.mmc-sort-list').slideUp();

$(document).on('change', '.mmc-sort-desktop input', function() {
var h =  $(this).val();
  $('.mmc-sort-header').html(h);
});


  
$(document).on('click', '.mmc-sort-header', function() {
  $('.mmc-sort-list').slideToggle();
});
$(document).on('click', function (event) {
  if (!$(event.target).closest('.mmc-sort-desktop').length) {
      $('.mmc-sort-list').slideUp();
  }
}); 
$(document).on('click', '.mmc-sort-desktop  label', function() {
  $('.mmc-sort-list').slideUp();
});
  
});

$(window).scroll(function() {
  $('.mmc-sort-list').slideUp();
});

$(document).on('change', '#meta_prod', function() {


  if($(this).is(":checked")){
    $(this).closest('.gift-box-product-main').addClass('input_opned');
  }
  else{
     $(this).closest('.gift-box-product-main').removeClass('input_opned');
  }
});

$(document).on('change', '#gift_product', function() {
  if($(this).is(":checked")){
    $(this).closest('.gift-box-product-main').addClass('input_opned');
  }
  else{
     $(this).closest('.gift-box-product-main').removeClass('input_opned');
  }
});


$(document).on('click', '#product-content_input-click-main', function() {
  var $giftBoxProductMain = $(this).closest('.gift-box-product-main');
  var $metaProdCheckbox = $giftBoxProductMain.find("#meta_prod");

  if ($metaProdCheckbox.prop('checked') || !$giftBoxProductMain.hasClass('input_opned')) {
    $giftBoxProductMain.addClass('input_opned');
  } else {
    $giftBoxProductMain.removeClass('input_opned');
  }
});



$(document).on('click', '#product-content_input-click', function() {
  var $giftBoxProductMain = $(this).closest('.gift-box-product-main');
  var $metaProdCheckbox = $giftBoxProductMain.find("#gift_product");

  if ($metaProdCheckbox.prop('checked') || !$giftBoxProductMain.hasClass('input_opned')) {
    $giftBoxProductMain.addClass('input_opned');
  } else {
    $giftBoxProductMain.removeClass('input_opned');
  }
});




